//#region IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
// CSS
import './SectionTitle.css';
//#endregion

//#region COMPONENT
/**
 * @function SectionTitle
 * @param {{background: string, children: React.ReactNode}} props
 * @returns {JSX.Element} The SectionTitle component
 */
const SectionTitle = props => {
  const { background, children } = props;
  return (
    <h1 className="SectionTitle" style={{ background }}>
      {children}
    </h1>
  );
};
//#endregion

//#region PROPERTIES
SectionTitle.propTypes = {
  background: PropTypes.string,
  children: PropTypes.node.isRequired,
};
//#endregion

export { SectionTitle };
